import axios from "axios";
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO = "https://customer-assets-cm19k8pv.emergentagent.net/job_41c2a71d-0b8d-4edd-b448-36c1defef6a6/artifacts/hatl1zc4_Gidza%20Institute%20-%20Logo%201.webp";

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("gidza_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
